<template>
  <div class="subTicket">
    <div class="name">
      {{ subTicket.name }}
    </div>
    <div class="formInputs">
      <div class="price">{{ formatCurrency(subTicket.price) }}</div>
      <NumberInputWithButtons
        :max="parseInt(subTicket.max_quantity, 10)"
        :min="0"
        v-model="subTicketCount"
      ></NumberInputWithButtons>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import NumberInputWithButtons from '../Form/NumberInputWithButtons.vue';
import formater from '../../lib/formater';

export default {
  name: 'SubTicket',
  components: { NumberInputWithButtons },
  computed: {
    subTicketCount: {
      get() {
        const ticket = this.$store.state.guidedTours.form.tickets[this.ticketId];
        if (typeof ticket !== 'undefined') {
          const { subTickets } = ticket;
          if (typeof subTickets === 'undefined') {
            return 0;
          }
          const st = subTickets[this.subTicket.id];
          if (typeof st === 'undefined') {
            return 0;
          }
          return st.count;
        }
        return 0;
      },
      set(v) {
        this.setFormSubTicketCount({
          ticketId: this.ticketId,
          subTicketId: this.subTicket.id,
          count: v,
        });
      },
    },
  },
  props: {
    ticketId: { type: Number, required: true },
    subTicket: { type: Object, required: true },
  },
  methods: {
    ...mapActions({
      setFormSubTicketCount: 'guidedTours/setFormSubTicketCount',
    }),
    formatCurrency(val) {
      return formater.currency(val);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../scss/grid';
.price {
  font-weight: 600;
  text-align: center;
}

.subTicket {
  margin-right: $sp;
  margin-left: $sp;
  display: flex;
  flex-wrap: wrap;
}
.name {
  padding-left: 0 !important;
  margin-bottom: $sp;
  flex-basis: 60%;
  align-self: center;
  @media screen and (max-width: $screen-sm) {
    flex-basis: 100%;
  }
}
.formInputs {
  flex-basis: 40%;
  @media screen and (max-width: $screen-sm) {
    flex-basis: 100%;
    margin-top: $sp;
  }
}
</style>
